<template>
    <div class="updatesProtocol_box">
        <van-popup v-model="show" round :close-on-click-overlay='false' :style="{ width: '85%' }">
            <div class="pop_box">
                <p class="title_p">温馨提示</p>
                <p class="content_p">
                    您需要同意相关协议才能享受兴川贷的相应服务
                </p>
                <div class="btn_box">
                    <van-button class="btn1" type="primary" @click="backStep">返回上一步</van-button>
                    <van-button class="btn2" type="primary" @click="handleContinue">同意并继续</van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
export default {
    name:'noAgree',
    props:{
        
    },
    data() {
        return {
            show:false
        }
    },

    methods:{
        // 返回上一步
        backStep() {
            this.$emit('backStep')
        },

        // 同意并继续
        handleContinue() {
            this.$emit('handleContinue')
        }
    }
}
</script>

<style lang="less" scoped>
.updatesProtocol_box {
    padding: 0 30px;
    .pop_box {
        padding: 30px 20px;
        text-align: center;
        .title_p {
            margin-top: 10px;
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #3B3B3B;
        }
        .content_p {
            margin-top: 15px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
            text-align: left;
        }
        .btn_box {
            display: flex;
            justify-content: center;
            margin-top: 30px;
            .btn1 {
                margin-right:15px;
                background-color: #f0f0f0;
                color: #777777;
                font-size: 13px;
                width: 120px;
                height: 40px;
                border: none;
            }
            .btn2 {
                background-color: #2E55E5;
                width: 120px;
                height: 40px;
                border: none;
                font-size: 13px;
                color: #FFFFFF;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/modules/Allpopup/noAgree.vue